import { useEffect, useState } from "react";
import API from "../../services/api";
import { TextField, MenuItem } from "@mui/material";
import {
    LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid,
    PieChart, Pie, Cell, Legend, ResponsiveContainer,
    BarChart, Bar
} from "recharts";
import { FaPhone, FaRupeeSign, FaCheckCircle, FaTimesCircle, FaClock } from "react-icons/fa";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

function Dashboard() {

    // ✅ ALL STATES FIRST
    const loggedInUser =
        JSON.parse(localStorage.getItem("user"));

    const userRole =
        (loggedInUser?.role || "").toLowerCase();

    const loggedEmployeeId =
        loggedInUser?.empId || "";

    const loggedBranchId =
        loggedInUser?.branchId || "";

    const allBranches =
        (loggedInUser?.allBranches || "N") === "Y";

    const branchManager =
        (loggedInUser?.branchManager || "N") === "Y";

    const isAdmin =
        userRole === "admin";

    const isManager =
        userRole === "manager";

    const isUser =
        userRole === "user";
    const location = useLocation();
    const [data, setData] = useState(null);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [employee, setEmployee] = useState("");
    useEffect(() => {

        // USER -> auto select own name
        if (isUser) {

            setEmployee(
                loggedEmployeeId || ""
            );
        }

    }, [isUser, loggedInUser]);
    const [status, setStatus] = useState("");
    const [employees, setEmployees] = useState([]);
    const [hoveredCard, setHoveredCard] = useState(null);
    const [trend, setTrend] = useState({});
    const navigate = useNavigate();

    // ✅ API CALL
    const loadData = async (f = fromDate, t = toDate, emp = employee, stat = status) => {

        // 🔹 helper to build query
        const buildQuery = (from, to, empVal, statVal) => {
            let q = [];

            if (from) q.push(`fromDate=${from}`);
            if (to) q.push(`toDate=${to}`);
            if (empVal) q.push(`employee=${empVal}`);
            if (statVal) q.push(`status=${statVal}`);

            // Role information
            q.push(`role=${userRole}`);
            q.push(`branchId=${loggedBranchId}`);
            q.push(`branchManager=${branchManager ? "Y" : "N"}`);
            q.push(`empId=${loggedEmployeeId}`);
            q.push(`allBranches=${allBranches ? "Y" : "N"}`);

            return q.join("&");
        };

        // 🔹 current data
        const currentUrl = `/dashboard/daily-calls?${buildQuery(f, t, emp, stat)}`;
        const currentRes = await API.get(currentUrl);
        //setData(currentRes.data);

        let dashboardData = currentRes.data;

        setData(dashboardData);
    };

    useEffect(() => {

        console.log("RAW URL:", location.search);

        const params = new URLSearchParams(location.search);

        const from = params.get("fromDate");
        const to = params.get("toDate");
        const emp = params.get("employee");
        const stat = params.get("status");

        // ✅ CORRECT CONDITION
        if (from && to) {

            // 🔥 drill-down case
            setFromDate(from);
            setToDate(to);
            setEmployee(emp || "");
            setStatus(stat || "");

            loadData(from, to, emp || "", stat || "");

        } else {

            // DEFAULT (LAST 7 DAYS)

            const today = new Date();
            const last7 = new Date();

            last7.setDate(today.getDate() - 7);

            const format = d => d.toLocaleDateString("en-CA");

            const fromDateVal = format(last7);
            const toDateVal = format(today);

            setFromDate(fromDateVal);
            setToDate(toDateVal);

            const employeeFilter =
                isUser
                    ? loggedEmployeeId
                    : "";

            loadData(
                fromDateVal,
                toDateVal,
                employeeFilter,
                ""
            );
        }

    }, [location.search]);



    useEffect(() => {

        API.get("/DailyCallReport/dropdowns-all")
            .then(res => {

                let employeeData = res.data.employees || [];

                // ADMIN + AllBranches=Y
                if (isAdmin && allBranches) {

                    // show all
                }

                // ADMIN + AllBranches=N
                else if (isAdmin && !allBranches) {

                    employeeData = employeeData.filter(
                        e => e.branchId === loggedBranchId
                    );
                }

                // MANAGER + BranchManager=Y
                else if (isManager && branchManager) {

                    employeeData = employeeData.filter(
                        e => e.branchId === loggedBranchId
                    );
                }

                // MANAGER + BranchManager=N
                else if (isManager && !branchManager) {

                    employeeData = employeeData.filter(
                        e => e.id === loggedEmployeeId
                    );
                }

                // USER
                else if (isUser) {

                    employeeData = employeeData.filter(
                        e => e.id === loggedEmployeeId
                    );
                }

                setEmployees(employeeData);
            });

    }, []);

    const handleLast7Days = () => {
        const today = new Date();
        const last7 = new Date();
        last7.setDate(today.getDate() - 7);

        const format = d => d.toLocaleDateString("en-CA");

        const from = format(last7);
        const to = format(today);

        setFromDate(from);
        setToDate(to);

        loadData(
            from,
            to,
            isUser ? loggedEmployeeId : "",
            status
        );
    };

    if (!data) return <div>Loading...</div>;

    const lineData = data.callsPerDay.map(x => ({
        date: new Date(x.date).toLocaleDateString(),
        count: x.count
    }));

    console.log("callsByEmployee raw:", data.callsByEmployee);

    const employeeData = data.callsByEmployee?.map(x => ({
        name: x.employee,
        employeeId: x.employeeId,
        count: x.count
    })) || [];

    const isSingleEmployee =
        employeeData.length === 1;

    console.log("Employee Data:", data.callsByEmployee);

    const pieData = data.callTypeDistribution.map(x => ({
        name: x.callType,
        value: x.count
    }));

    const renderTrend = (t) => {
        if (!t) return null;

        return (
            <div style={{
                ...styles.trend,
                color: t.isUp ? "#2ed573" : "#ff4757"
            }}>
                {t.isUp ? <FaArrowUp size={10} /> : <FaArrowDown size={10} />}
                {Math.abs(t.value).toFixed(1)}%
            </div>
        );
    };

    const handleDrillDown = (extraFilters = {}) => {

        console.log("extraFilters received:", extraFilters);

        const params = new URLSearchParams();

        // Dates
        params.set("fromDate", extraFilters.fromDate || fromDate);
        params.set("toDate", extraFilters.toDate || toDate);

        // Employee
        if (extraFilters.employee || employee) {
            params.set("employee", extraFilters.employee || employee);
        }

        // Status
        if (extraFilters.status) {
            params.set("status", extraFilters.status);
        }

        // Call Type
        if (extraFilters.callType) {
            params.set("callType", extraFilters.callType);
        }

        // ✅ Min Value (important fix)
        if (extraFilters.minValue !== undefined && extraFilters.minValue !== "") {
            params.set("minValue", extraFilters.minValue);
        }

        console.log("FINAL PARAMS:", params.toString());

        navigate(`/app/daily-call-report?${params.toString()}`);
    };
    return (
        <div style={styles.container}>

            <div style={styles.header}>
                <h2>Daily Call - Dashboard</h2>
            </div>

            <div style={styles.filterRow}>
                <input
                    type="date"
                    value={fromDate}
                    onChange={e => setFromDate(e.target.value)}
                    style={styles.input}
                />

                <input
                    type="date"
                    value={toDate}
                    onChange={e => setToDate(e.target.value)}
                    style={styles.input}
                />

                <TextField
                    select
                    label="Employee"
                    value={employee}
                    disabled={isUser}
                    onChange={(e) => setEmployee(e.target.value)}
                    size="small"
                    sx={styles.inputStyle}
                >
                    {!isUser && (
                        <MenuItem value="" sx={styles.menuItem}>
                            All
                        </MenuItem>
                    )}

                    {employees.map(emp => (

                        <MenuItem
                            key={emp.id}
                            value={emp.id}
                            sx={styles.menuItem}
                        >
                            <div style={{
                                display: "flex",
                                width: "100%",
                                alignItems: "center"
                            }}>

                                {/* EMPLOYEE */}
                                <span style={{
                                    width: "160px",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis"
                                }}>
                                    {emp.empName}
                                </span>

                                {/* BRANCH */}
                                <span style={{
                                    width: "140px"
                                }}>
                                    {"-> "} {emp.branchName}
                                </span>

                                {/* MOBILE */}
                                <span>
                                    {"-> "} {emp.mobileNo}
                                </span>

                            </div>
                        </MenuItem>

                    ))}
                </TextField>

                <TextField
                    select
                    label="Status"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    size="small"
                    sx={styles.inputStyle}
                >
                    <MenuItem value="" sx={styles.menuItem}>All</MenuItem>
                    <MenuItem value="Active" sx={styles.menuItem}>Active</MenuItem>
                    <MenuItem value="Closed" sx={styles.menuItem}>Closed</MenuItem>
                    <MenuItem value="Pending" sx={styles.menuItem}>Pending</MenuItem>
                </TextField>

                <button style={styles.filterBtn} onClick={() => loadData()}>
                    Filter
                </button>

                <button style={styles.last7Btn} onClick={handleLast7Days}>
                    Last 7 Days
                </button>
            </div>

            <div style={styles.cardRow}>

                {/* TOTAL CALLS */}
                <div
                    style={{
                        ...styles.cardBase,
                        ...styles.cardTotal,
                        ...(hoveredCard === "total" && styles.cardHover)
                    }}
                    onMouseEnter={() => setHoveredCard("total")}
                    onMouseLeave={() => setHoveredCard(null)}
                    onClick={() => {
                        const avg = data.totalValue / data.totalCalls;
                        const threshold = Math.round(avg);

                        handleDrillDown({ minValue: threshold });
                    }}   // ✅ no status here
                >
                    <div style={styles.cardContent}>
                        <FaPhone size={16} />
                        <h3 style={styles.cardTitle}>Total Calls</h3>
                    </div>

                    <p style={styles.cardValueText}>{data.totalCalls}</p>
                    {renderTrend(trend.totalCalls)}
                </div>

                {/* TOTAL VALUE */}
                <div
                    style={{
                        ...styles.cardBase,
                        ...styles.cardValue,
                        ...(hoveredCard === "value" && styles.cardHover)
                    }}
                    onMouseEnter={() => setHoveredCard("value")}
                    onMouseLeave={() => setHoveredCard(null)}
                    onClick={() => {
                        const avg = data.totalValue / data.totalCalls;
                        const threshold = Math.round(avg);

                        handleDrillDown({ minValue: threshold });
                    }}   // 🔥 drill
                >
                    <div style={styles.cardContent}>
                        <FaRupeeSign size={16} />
                        <h3 style={styles.cardTitle}>Total Value</h3>
                    </div>

                    <p style={styles.cardValueText}>₹ {data.totalValue}</p>
                    {renderTrend(trend.totalValue)}
                </div>

                {/* ACTIVE */}
                <div
                    style={{
                        ...styles.cardBase,
                        ...styles.cardActive,
                        ...(hoveredCard === "active" && styles.cardHover)
                    }}
                    onMouseEnter={() => setHoveredCard("active")}
                    onMouseLeave={() => setHoveredCard(null)}
                    onClick={() => handleDrillDown({ status: "Active" })}   // 🔥 drill
                >
                    <div style={styles.cardContent}>
                        <FaCheckCircle size={16} />
                        <h3 style={styles.cardTitle}>Active</h3>
                    </div>

                    <p style={styles.cardValueText}>{data.activeCount}</p>
                    {renderTrend(trend.active)}
                </div>

                {/* CLOSED */}
                <div
                    style={{
                        ...styles.cardBase,
                        ...styles.cardClosed,
                        ...(hoveredCard === "closed" && styles.cardHover)
                    }}
                    onMouseEnter={() => setHoveredCard("closed")}
                    onMouseLeave={() => setHoveredCard(null)}
                    onClick={() => handleDrillDown({ status: "Closed" })}   // 🔥 drill
                >
                    <div style={styles.cardContent}>
                        <FaTimesCircle size={16} />
                        <h3 style={styles.cardTitle}>Closed</h3>
                    </div>

                    <p style={styles.cardValueText}>{data.closedCount}</p>
                    {renderTrend(trend.closed)}
                </div>

                {/* PENDING */}
                <div
                    style={{
                        ...styles.cardBase,
                        ...styles.cardPending,
                        ...(hoveredCard === "pending" && styles.cardHover)
                    }}
                    onMouseEnter={() => setHoveredCard("pending")}
                    onMouseLeave={() => setHoveredCard(null)}
                    onClick={() => handleDrillDown({ status: "Pending" })}   // 🔥 drill
                >
                    <div style={styles.cardContent}>
                        <FaClock size={16} />
                        <h3 style={styles.cardTitle}>Pending</h3>
                    </div>

                    <p style={styles.cardValueText}>{data.pendingCount}</p>
                    {renderTrend(trend.pending)}
                </div>

            </div>

            <div style={styles.chartRow}>

                <div style={styles.chartBox}>
                    <h3>Calls Per Day</h3>

                    <ResponsiveContainer width="100%" height={320}>
                        <LineChart data={lineData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <Tooltip />
                            <Line
                                type="monotone"
                                dataKey="count"
                                stroke="#3742fa"
                                dot={{ r: 5 }}
                                activeDot={{
                                    r: 7,
                                    onClick: (e, payload) => {
                                        if (!payload) return;

                                        const selectedDate = new Date(payload.payload.date)
                                            .toLocaleDateString("en-CA");

                                        handleDrillDown({
                                            fromDate: selectedDate,
                                            toDate: selectedDate
                                        });
                                    }
                                }}
                            />
                        </LineChart>
                    </ResponsiveContainer>
                </div>

                <div style={styles.chartBox}>
                    <h3>Call Type Distribution</h3>

                    <ResponsiveContainer width="100%" height={320}>
                        <PieChart margin={{ top: 10, right: 20, left: 20, bottom: 40 }}>
                            <Pie
                                data={pieData}
                                dataKey="value"
                                nameKey="name"
                                outerRadius={100}
                                onClick={(data) => {
                                    handleDrillDown({ callType: data.name });
                                }}
                                label={({ percent }) =>
                                    percent > 0.05 ? `${(percent * 100).toFixed(0)}%` : ""
                                }
                            >
                                {pieData.map((entry, index) => (
                                    <Cell key={index} fill={`hsl(${index * 40},70%,60%)`} />
                                ))}
                            </Pie>
                            <Tooltip />
                            <Legend verticalAlign="bottom" height={50} />
                        </PieChart>
                    </ResponsiveContainer>
                </div>

            </div>
          
            {!isSingleEmployee ? (

                // Employee comparison chart

                <div style={styles.chartBox}>
                    <h3>Calls by Employee</h3>

                    <ResponsiveContainer width="100%" height={320}>
                        <BarChart data={employeeData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Bar
                                dataKey="count"
                                fill="#1e90ff"
                                onClick={(data) => {
                                    if (!data || !data.payload) return;

                                    handleDrillDown({
                                        employee: data.payload.employeeId
                                    });
                                }}
                            />
                        </BarChart>
                    </ResponsiveContainer>
                </div>

            ) : (

                // Single employee → show date trend

                <div style={styles.chartBox}>
                    <h3>Calls by Date</h3>

                    <ResponsiveContainer width="100%" height={320}>
                        <BarChart data={lineData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <Tooltip />
                            <Bar
                                dataKey="count"
                                fill="#1e90ff"
                            />
                        </BarChart>
                    </ResponsiveContainer>
                </div>

            )}
        </div>
    );
}

const styles = {
    container: {
        padding: "10px",
        fontFamily: "Verdana",
        fontSize: "12px"
    },
    header: {
        background: "#2f3542",
        color: "#fff",
        padding: "6px",
        borderRadius: "6px",
        marginBottom: "10px"
    },
    filterRow: {
        display: "flex",
        flexWrap: "wrap",        // 🔥 wrap items
        gap: "10px",
        alignItems: "center",
        marginBottom: "10px"
    },
    input: {
        padding: "6px",
        borderRadius: "4px",
        border: "1px solid #ccc"
    },
    filterBtn: {
        background: "#2ed573",
        border: "none",
        padding: "6px 12px",
        color: "#fff",
        borderRadius: "4px",
        cursor: "pointer"
    },
    last7Btn: {
        background: "#1e90ff",
        border: "none",
        padding: "6px 12px",
        color: "#fff",
        borderRadius: "4px",
        cursor: "pointer"
    },
    cardRow: {
        display: "flex",
        gap: "10px",
        marginTop: "10px"
    },
    card: {
        background: "#fff",
        padding: "10px",
        borderRadius: "6px",
        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        flex: "1 1 150px",        // 🔥 responsive width
        textAlign: "center"
    },
    chartRow: {
        display: "flex",
        gap: "20px",
        marginTop: "20px"
    },
    chartBox: {
        background: "#fff",
        padding: "15px",
        borderRadius: "6px",
        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        flex: "1 1 400px",       // 🔥 responsive
        minWidth: "300px"
    },
    inputStyle: {
        minWidth: "140px",
        flex: "1 1 150px",
        "& .MuiOutlinedInput-root": {
            height: "32px",
            fontSize: "12px",
            fontFamily: "Verdana"
        },
        "& .MuiInputBase-input": {
            padding: "8px 10px",
            fontFamily: "Verdana",
            fontSize: "12px"
        },
        "& .MuiInputLabel-root": {
            fontFamily: "Verdana",
            fontSize: "12px"
        }
    },
    menuItem: {
        fontFamily: "Verdana",
        fontSize: "12px"
    },
    container: {
        padding: "10px",
        fontFamily: "Verdana",
        fontSize: "12px",
        maxWidth: "100%",        // 🔥 prevent overflow
        boxSizing: "border-box"
    },
    cardBase: {
        padding: "18px 12px",
        borderRadius: "8px",                  // 🔥 slightly smoother
        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
        flex: "1 1 150px",
        textAlign: "center",
        color: "#fff",
        cursor: "pointer",                   // 🔥 interactive feel
        transition: "all 0.2s ease"          // 🔥 smooth animation
    },

    cardTotal: {
        background: "#57606f"   // neutral
    },

    cardValue: {
        background: "#2ed573"   // green (money)
    },

    cardActive: {
        background: "#1e90ff"   // blue
    },

    cardClosed: {
        background: "#747d8c"   // gray
    },

    cardPending: {
        background: "#ff4757"   // red
    },
    cardTitle: {
        margin: 0,
        fontSize: "12px",
        fontWeight: "500"
    },

    cardValueText: {
        margin: 0,
        fontSize: "15px",
        fontWeight: "bold"
    },
    cardContent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        marginBottom: "4px"
    },
    cardHover: {
        transform: "translateY(-4px)",
        boxShadow: "0 8px 18px rgba(0,0,0,0.2)"
    },
    cardTotal: {
        background: "linear-gradient(135deg, #57606f, #2f3542)"
    },

    cardValue: {
        background: "linear-gradient(135deg, #2ed573, #1eae60)"
    },

    cardActive: {
        background: "linear-gradient(135deg, #1e90ff, #3742fa)"
    },

    cardClosed: {
        background: "linear-gradient(135deg, #747d8c, #57606f)"
    },

    cardPending: {
        background: "linear-gradient(135deg, #ff6b81, #ff4757)"
    },
    trend: {
        fontSize: "11px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "3px",
        marginTop: "3px",
        fontWeight: "bold"
    },
};

export default Dashboard;